"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = register;
var configuration_1 = require("./configuration");
var utils_1 = require("./utils");
var login_1 = require("./login");
var logout_1 = require("./logout");
var flags_1 = require("./flags");
function isTrustpilotApiRequest(url) {
    if (!url) {
        return false;
    }
    return configuration_1.configuration.authorizeTrustpilotApiHosts.some(function (host) { return url.indexOf(host) === 0; });
}
function getOrRefreshAccessToken() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ((0, utils_1.hasAccessToken)()) {
                return [2 /*return*/, (0, utils_1.getAccessToken)()];
            }
            return [2 /*return*/, (0, login_1.refreshAccessToken)()];
        });
    });
}
function beforeRequestHandler(config) {
    return __awaiter(this, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isTrustpilotApiRequest(config.url)) {
                        return [2 /*return*/, config];
                    }
                    if (flags_1.flags.exchangeAccessTokenInProgress) {
                        throw new Error("Access token exchange is in progress");
                    }
                    return [4 /*yield*/, getOrRefreshAccessToken()];
                case 1:
                    token = _a.sent();
                    if (!config.headers)
                        config.headers = {};
                    config.headers.Authorization = "Bearer ".concat(token);
                    return [2 /*return*/, config];
            }
        });
    });
}
function isApigeeTokenExpiredError(response) {
    return (response &&
        response.fault &&
        response.fault.detail &&
        "keymanagement.service.access_token_expired" ===
            response.fault.detail.errorcode);
}
function isInvalidTokenError(axios, response) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(response.status === 403)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("".concat(configuration_1.configuration.trustpilotApi.host, "/v1/private/me"), {
                            transformResponse: function (data) { return (__assign(__assign({}, JSON.parse(data)), { 
                                // This is a special flag to prevent the interceptor from intercepting this request
                                tokenValidityCheck: true })); },
                        })];
                case 2:
                    _a.sent();
                    // If the request was successful, the token is valid
                    return [2 /*return*/, false];
                case 3:
                    error_1 = _a.sent();
                    if (error_1.response && error_1.response.status === 403) {
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    });
}
function isApigeeTokenError(response) {
    return (response &&
        response.fault &&
        response.fault.detail &&
        [
            "oauth.v2.InvalidAccessToken", // No token included in request
            "keymanagement.service.invalid_access_token", // Token doesn't exist (may have been deleted)
            "keymanagement.service.access_token_not_approved", // Token isn't approved (may have been revoked)
            "keymanagement.service.access_token_expired", // Token expired
        ].some(function (errorCode) { return errorCode === response.fault.detail.errorcode; }));
}
function isAuthenticationApiRequest(url) {
    return url.indexOf(configuration_1.configuration.businessAppAuthenticationApi.host) === 0;
}
function errorHandler(axios, error) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!error.response) return [3 /*break*/, 4];
                    response = error.response;
                    // The response errored while trying to determine if the token is valid
                    // Exempt these requests from the interceptor
                    if (response.data && response.data.tokenValidityCheck) {
                        throw error;
                    }
                    if (!response.config || !response.config.url) {
                        // The error does not have a config + url  which means there was something wrong with the request
                        throw error;
                    }
                    if (isAuthenticationApiRequest(response.config.url)) {
                        if (response.config.url.endsWith("/oauth/revoke")) {
                            throw new Error("Failed to revoke access token: ".concat(error));
                        }
                        return [2 /*return*/, (0, logout_1.logout)()];
                    }
                    if (!isTrustpilotApiRequest(response.config.url)) {
                        /*
                         * The request was not made to TP api so not auth related
                         */
                        throw error;
                    }
                    if (!isApigeeTokenExpiredError(response.data)) return [3 /*break*/, 2];
                    // The token was expired. Refresh and retry the original request
                    // If the original request fails, log the user out
                    return [4 /*yield*/, (0, login_1.refreshAccessToken)()];
                case 1:
                    // The token was expired. Refresh and retry the original request
                    // If the original request fails, log the user out
                    _a.sent();
                    return [2 /*return*/, axios.request(response.config).catch(function (error) {
                            if (error.response.status === 401) {
                                return (0, logout_1.logout)();
                            }
                        })];
                case 2:
                    if (response.status === 401 && isApigeeTokenError(response.data)) {
                        // The response was a 401 because of token issues from apigee
                        return [2 /*return*/, (0, logout_1.logout)()];
                    }
                    return [4 /*yield*/, isInvalidTokenError(axios, response)];
                case 3:
                    if (_a.sent()) {
                        return [2 /*return*/, (0, logout_1.logout)()];
                    }
                    _a.label = 4;
                case 4: throw error;
            }
        });
    });
}
function register(axios) {
    if (!configuration_1.configuration.init) {
        return;
    }
    axios.interceptors.request.use(function (config) {
        return beforeRequestHandler(config);
    }, function (error) { return Promise.reject(error); });
    axios.interceptors.response.use(undefined, function (error) {
        return errorHandler(axios, error);
    });
}
//# sourceMappingURL=axios-interceptor.js.map